import type { IElectionOfficialResponse } from '../../../interface/state/IElectionOfficial';
import type { IElectionOfficialByIDState, IGetElectionOfficial } from '../../../interface/state/IElectionState';
import { electionOfficialType } from '../../types';
import { createAPI, deleteByIdAPI, getAPI, getByIdAPI, updateByIdAPI } from '../api-utils';

export interface IResultUploadAssignment {
	code: string;
	name: string;
	resultType: string;
	isCompleted?: boolean;
}

export interface ICreateElectionOfficial {
	userId: number;
	electionId: number;
	name: string;
	assignments: IResultUploadAssignment[];
}

export const create = createAPI<undefined, ICreateElectionOfficial>({
	actionType: electionOfficialType.create,
	url: '/api/v1/ElectionOfficial',
});

export const createBulk = createAPI<undefined, ICreateElectionOfficial[]>({
	actionType: electionOfficialType.createBulk,
	url: '/api/v1/ElectionOfficial/bulk-assignment',
});

export const get = getAPI<IGetElectionOfficial>({
	actionType: electionOfficialType.get,
	url: '/api/v1/ElectionOfficial',
});

export const getById = getByIdAPI<IElectionOfficialByIDState>({
	actionType: electionOfficialType.getById,
	url: '/api/v1/ElectionOfficial',
});

export interface IUpdateElectionOfficial {
	id: string;
	userId: number;
	electionId: number;
	election: string;
	name: string;
	assignment: IResultUploadAssignment;
}

export const update = updateByIdAPI<undefined, IUpdateElectionOfficial>({
	actionType: electionOfficialType.update,
	url: '/api/v1/ElectionOfficial/update',
});

export const deleteById = deleteByIdAPI({
	actionType: electionOfficialType.deleteById,
	url: '/api/v1/ElectionOfficial/delete',
});

export const updateStatus = updateByIdAPI<
	undefined,
	{
		isCompleted: boolean;
	}
>({
	actionType: electionOfficialType.updateStatus,
	url: '/api/v1/ElectionOfficial/update-status',
});

export const filterBy = getAPI<IElectionOfficialResponse>({
	actionType: electionOfficialType.filterBy,
	url: '/api/v1/ElectionOfficial/filter',
	type: 'core',
});
